import IconMinus from '@components/icons/IconMinus';
import IconPlus from '@components/icons/IconPlus';
import { stEditorAmap } from '../STAMap';

export function MapZoomWidget() {
  return (
    <div className="absolute left-20 bottom-20 flex flex-col items-center gap-10 p-10 bg-white rounded">
      <IconPlus scheme="light" onClick={() => stEditorAmap.changeZoom(0.1)} />
      <IconMinus scheme="light" onClick={() => stEditorAmap.changeZoom(-0.1)} />
    </div>
  );
}
